<template>
  <Teleport to="body">
    <Transition name="auth-modal-fade">
      <div v-if="authModalStore.isOpen" class="auth-modal-overlay">
        <div
          class="auth-modal-panel"
          role="dialog"
          aria-modal="true"
          aria-label="Sign in or sign up"
        >
          <button
            type="button"
            class="auth-modal-close-btn"
            aria-label="Close authentication modal"
            @click="handleClose"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <AuthFlowShell :initial-mode="authModalStore.mode" @success="handleSuccess" />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { onBeforeUnmount, onMounted, watch } from 'vue'
import AuthFlowShell from '@/components/auth/AuthFlowShell.vue'
import { useAuthModalStore } from '@/stores/authModal'

const authModalStore = useAuthModalStore()

const handleClose = () => {
  authModalStore.close()
}

const handleSuccess = () => {
  authModalStore.close()
}

const onWindowKeydown = () => {
  // Escape key intentionally does not close the modal.
  // Only the close button should dismiss it.
}

watch(
  () => authModalStore.isOpen,
  (isOpen) => {
    document.body.style.overflow = isOpen ? 'hidden' : ''
  }
)

onMounted(() => {
  window.addEventListener('keydown', onWindowKeydown)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onWindowKeydown)
  document.body.style.overflow = ''
})
</script>

<style scoped>
.auth-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
}

.auth-modal-panel {
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  position: relative;
}

.auth-modal-close-btn {
  position: absolute;
  top: 24px;
  right: 16px;
  z-index: 3;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 999px;
  background: rgba(17, 24, 39, 0.7);
  color: #fff;
  font-size: 24px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.auth-modal-fade-enter-active,
.auth-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.auth-modal-fade-enter-from,
.auth-modal-fade-leave-to {
  opacity: 0;
}

@media (max-width: 767px) {
  .auth-modal-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .auth-modal-panel {
    max-width: 100%;
    height: 100dvh;
    overflow-y: auto;
    background: #fff;
    border-radius: 0;
  }

  .auth-modal-close-btn {
    top: 14px;
    right: 14px;
  }
}
</style>
